<template>
  <div class="modal_dim on">
    <!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal w80p">
          <div class="modal_con">
            <div class="print_wrap">
              <div class="print">
                <div class="table">
                  <div class="row">
                    <div class="col right_bo">
                      <div class="row" style="flex: 1;">
                        <div class="cell fix150"><p>수험표 출력</p></div>
                        <div class="cell">
                          <p class="left">
                                <span style="font-size: 24rem;font-weight: bold;">
                                    {{ data.item.exam.year }}년 제 {{ data.item.exam.rounds }}회 정기 / 비정기 자격시험
                                </span><br>
                          </p>
                        </div>
                      </div>
                      <div class="row fix70">
                        <div class="cell fix150"><p>수험번호</p></div>
                        <div class="cell"><p class="left">{{ data.item.userExam.examinationCode }}</p></div>
                        <div class="cell fix150"><p>시험구분</p></div>
                        <div class="cell fix150"><p class="left">{{ data.item.exam.rating }}급 {{ data.item.exam.part }}</p></div>
                      </div>
                    </div>
                    <div class="col" style="flex: 0 0 120rem;">
                      <div class="cell" style="padding: 0;">
                        <p><img :src="$ConstCode.getImagePath(data.item.userExam.userProfile)" alt=""></p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="cell">
                      <p>
                        <span style="font-size: 14rem;color: red;">
                            ※ 본 수험표를 지참한 후 검정당일 감독위원에게 제시하시기 바랍니다.
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>종 목 명</p></div>
                    <div class="cell"><p class="left">외식경영관리사</p></div>
                    <div class="cell fix150"><p>이름(영문)</p></div>
                    <div class="cell"><p class="left">{{ data.item.userExam.enName }}</p></div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>이름(한글)</p></div>
                    <div class="cell"><p class="left">{{ data.item.userExam.koName }}</p></div>
                    <div class="cell fix150"><p>생년월일</p></div>
                    <div class="cell"><p>{{ dateFormat(data.item.userExam.userBirth) }}</p></div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>일시 및<br>장소</p></div>
                    <div class="cell">
                      <p class="left">
                        <span style="color: blue;">
                          ○ 일 시: {{ dateFormat(data.item.exam.examDate) }}({{ getDate(data.item.exam.examDate) }})
                          {{ data.item.exam.time }}까지 입실완료</span><br>
                        ○ 장 소: {{ data.item.exam.address }} {{ data.item.exam.address2 }}
                      </p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>합격(예정)자<br>발표일자</p></div>
                    <div class="cell">
                      <p class="left">
                        {{ dateFormat(data.item.exam.passDate) }}
                        ({{ getDate(data.item.exam.passDate) }}) {{ data.item.passTime }}<br>
                        <span style="color: #FF9F00;font-size: 15rem;">※ 인터넷 공지(www.kofsia.or.kr) 및 개별문자 안내</span>
                      </p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>자격증<br>신청방법</p></div>
                    <div class="cell"><p class="left">(사)한국외식산업협회 홈페이지</p></div>
                  </div>
                  <div class="row fix70">
                    <div class="cell fix150"><p>검정응시료<br>환불안내</p></div>
                    <div class="cell">
                      <p class="left">
                        {{ dateFormat(data.item.exam.reStartDate) }} ({{ getDate(data.item.exam.reStartDate) }}) 00:00 ~
                        {{ dateFormat(data.item.exam.reEndDate) }} ({{ getDate(data.item.exam.reEndDate) }})
                        23:59 [{{ data.item.exam.percent }}% 환불]<br>
                        {{ dateFormat(data.item.exam.reStartDate2) }} ({{ getDate(data.item.exam.reStartDate2) }}) 00:00 ~
                        {{ dateFormat(data.item.exam.reEndDate2) }} ({{ getDate(data.item.exam.reEndDate2) }})
                        23:59 [ {{ data.item.exam.percent2 }}% 환불]<br>
                        <span style="color: #FF9F00;font-size: 15rem;">※ 환불기간 이후에는 수강료 환불이 불가합니다.</span>
                      </p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell"><p>기타사항</p></div>
                  </div>
                  <div class="row">
                    <div class="cell">
                      <p class="left" style="font-size: 16rem;">
                        ◎ 선택과목 : [필기시험: 해당없음]<br>
                        ◎ 면제과목 : [필기시험: 해당없음]<br>
                        ◎ 장애여부 및 편의 요청사항 :<br>
                        (장애 응시 편의사항 요청자는 원수접수 기간 내에 장애인 수첩 등
                        관련 <span style="font-weight: bold;">증비서류를 시험 시행기관에 제출해야 하며 심사 결과에 따라 편의제공
                        내용이 달라질 수 있음)</span>
                      </p>
                    </div>
                  </div>
                  <div class="row fix70">
                    <div class="cell"><p>수험자 유의사항</p></div>
                  </div>
                  <div class="row">
                    <div class="cell">
                      <ol class="nb_dot" style="font-size: 16rem;">
                        <li>
                            <span class="ol_li_txt">
                                수험표에 기재된 내용을 반드시 확인하여 시험응시에 착오가 없도록 하시기 바랍니다.
                            </span>
                        </li>
                        <li>
                            <span class="ol_li_txt">
                                수험원서 및 답안지 등의 기재착오, 누락 등으로 인한 불이익은 일체
                                수험자의 책임이오니 유의하시기 바랍니다.
                            </span>
                        </li>
                        <li>
                            <span class="ol_li_txt">
                                <span style="color: red;">전자·통신기기</span>(전자계산기, 수험자지참공구 등 협회에서 사전 소지를
                                지정한 물품 제외)의 <span style="color: red;">시험장 반입은 원칙적으로 금지</span>됩니다.
                            </span>
                        </li>
                        <li>
                            <span class="ol_li_txt">
                                소지품 정리시간 이후 전자·통신기기 등 소지 불가 물품을 소지·착용하고 있는
                                경우에는 해당 회별 시험이 정지(퇴실) 및 무효처리 됩니다.
                            </span>
                        </li>
                        <li>
                            <span class="ol_li_txt">
                                수험자는 필기시험 시 (1)수험표 (2)신분증 (3)흑색볼펜 (4)컴퓨터용
                                사인펜 등을 지참하여 <span style="color: red;">시험 시작 20분 전</span>에 지정된 고사실에 입실 완료해야 합니다.
                            </span>
                        </li>
                        <li>
                            <span class="ol_li_txt">
                                시험시간 중 필기도구 등을 빌리거나 빌려줄 수 없습니다.
                            </span>
                        </li>
                        <li>
                            <span class="ol_li_txt">
                                시험 관련 부당한 행위를 한 때에는 당해 시험이 중지 또는 무효가 되며,
                                앞으로 5년 동안 시험을 응시할 수 있는 자격을 정지합니다.
                            </span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo grey" @click="$emit('eventClose')">
                이전으로
              </button>
              <button class="btn" @click="fnPrint">출력하기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-exam-admission-popup',
  props: {
    data: {
      type: [Array, Object],
      default: () => {}
    },
    callBack: {
      type: [Function]
    }
  },
  methods: {
    dateFormat: function(date) {
      return this.$moment(date).format('YYYY년 MM월 DD일')
    },
    getDate: function(date) {
      const newDate = this.$moment(date)
      const week = ['일', '월', '화', '수', '목', '금', '토']
      const today = newDate.day()
      return week[today]
    },
    fnPrint: function() {
      const html = document.querySelector('html')
      const printContents = document.querySelector('.modal_con').innerHTML
      const printDiv = document.createElement('div')
      printDiv.className = 'print-div'

      html.appendChild(printDiv)
      printDiv.innerHTML = printContents
      document.body.style.display = 'none'
      window.print()
      document.body.style.display = 'block'
      printDiv.style.display = 'none'
    },
  }
}
</script>

<style scoped></style>
